import { useI18n } from './I18nContext'
import { LANGS, LANG_NAMES, LANG_SHORT, type Lang } from './types'

/**
 * Sélecteur de langue.
 *
 * Deux formes pour deux contextes : `segmented` sur l'écran de connexion et au
 * bas du menu, où la place existe et où les deux langues doivent se voir d'un
 * coup d'œil ; `compact` quand le menu est rabattu.
 *
 * Chaque langue est écrite dans sa propre langue : un lecteur anglophone
 * cherche « English », pas « Anglais ».
 */
export function LanguageSwitcher({ variant = 'segmented' }: { variant?: 'segmented' | 'compact' }) {
  const { lang, setLang, t } = useI18n()

  if (variant === 'compact') {
    const next: Lang = lang === 'fr' ? 'en' : 'fr'
    return (
      <button
        type="button"
        className="lang-toggle"
        onClick={() => setLang(next)}
        title={`${t('lang.choose')} : ${LANG_NAMES[next]}`}
        aria-label={`${t('lang.choose')} : ${LANG_NAMES[next]}`}
      >
        {LANG_SHORT[lang]}
      </button>
    )
  }

  return (
    <div className="lang-switch" role="radiogroup" aria-label={t('lang.choose')}>
      {LANGS.map((code) => (
        <button
          key={code}
          type="button"
          role="radio"
          aria-checked={lang === code}
          className="lang-switch-option"
          onClick={() => setLang(code)}
          lang={code}
        >
          {LANG_NAMES[code]}
        </button>
      ))}
    </div>
  )
}
